import './LegalNotice.scss';

import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import LinkLikeButton from '@/common/components/blocks/LinkLikeButton/LinkLikeButton';
import Accordion from '@/common/components/molecules/Accordion/Accordion';
import { ROUTE_HOME } from '@/common/constants';
import { useHistoryContext } from '@/common/contexts/HistoryContext/HistoryContext';
import useTheme from '@/common/hooks/useTheme';
import { ReactComponent as ChevronSvg } from '@/ebat/assets/icons/chevron-left.svg';

const LegalNotice = () => {
  const { t } = useTranslation();
  const { Logo } = useTheme();

  const { historyQueue } = useHistoryContext();

  /* eslint-disable jsx-a11y/heading-has-content */
  const transComponents = {
    h2: <h2 />,
    h3: <h3 />,
    h4: <h4 />,
    p: <p />,
    div: <div />,
    bullet: '•',
  };
  /* eslint-enable jsx-a11y/heading-has-content */

  return (
    <div className="modal-legals" data-qa-id="modal-legals">
      <div className="modal-legals__top">
        <LinkLikeButton
          className="close-button"
          variant="primary"
          buttonSize="medium"
          context="create-account"
          url={historyQueue[1]?.pathname || ROUTE_HOME}
        >
          <ChevronSvg />
          {t('common:messages:actions.close')}
        </LinkLikeButton>
        <Logo className="logo" />
      </div>

      <div className="modal-legals__content">
        <h1 className="title">
          <Trans
            allowHTML
            components={transComponents}
            i18nKey="ebat:entities:common.legals.title"
          />
        </h1>
        <div className="mobile">
          <Accordion
            accordionLabel={
              <Trans
                allowHTML
                components={transComponents}
                i18nKey="ebat:entities:common.legals.first_content_title"
              />
            }
          >
            <Trans
              allowHTML
              components={transComponents}
              i18nKey="ebat:entities:common.legals.first_content"
            />
          </Accordion>
          <Accordion
            accordionLabel={
              <Trans
                allowHTML
                components={transComponents}
                i18nKey="ebat:entities:common.legals.second_content_title"
              />
            }
            isOpen={false}
          >
            <Trans
              allowHTML
              components={transComponents}
              i18nKey="ebat:entities:common.legals.second_content"
            />
          </Accordion>
          <Accordion
            accordionLabel={
              <Trans
                allowHTML
                components={transComponents}
                i18nKey="ebat:entities:common.legals.third_content_title"
              />
            }
            isOpen={false}
          >
            <Trans
              allowHTML
              components={transComponents}
              i18nKey="ebat:entities:common.legals.third_content"
            />
          </Accordion>
          <Accordion
            accordionLabel={
              <Trans
                allowHTML
                components={transComponents}
                i18nKey="ebat:entities:common.legals.fourth_content_title"
              />
            }
            isOpen={false}
          >
            <Trans
              allowHTML
              components={transComponents}
              i18nKey="ebat:entities:common.legals.fourth_content"
            />
          </Accordion>
        </div>
        <div className="tablet">
          <div className="fake-accordion accordion--open">
            <div className="fake-accordion__title">
              {t('ebat:entities:common.legals.first_content_title')}
            </div>
            <div className="fake-accordion__content">
              <Trans
                allowHTML
                components={transComponents}
                i18nKey="ebat:entities:common.legals.first_content"
              />
            </div>
          </div>
          <div className="middle-container">
            <div className="fake-accordion accordion--open">
              <div className="fake-accordion__title">
                {t('ebat:entities:common.legals.second_content_title')}
              </div>
              <div className="fake-accordion__content">
                <Trans
                  allowHTML
                  components={transComponents}
                  i18nKey="ebat:entities:common.legals.second_content"
                />
              </div>
            </div>
            <div className="fake-accordion accordion--open">
              <div className="fake-accordion__title">
                {t('ebat:entities:common.legals.third_content_title')}
              </div>
              <div className="fake-accordion__content">
                <Trans
                  allowHTML
                  components={transComponents}
                  i18nKey="ebat:entities:common.legals.third_content"
                />
              </div>
            </div>
          </div>
          <div className="fake-accordion accordion--open">
            <div className="fake-accordion__title">
              {t('ebat:entities:common.legals.fourth_content_title')}
            </div>
            <div className="fake-accordion__content">
              <Trans
                allowHTML
                components={transComponents}
                i18nKey="ebat:entities:common.legals.fourth_content"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalNotice;
